<template>
  <v-card class="fs-status-card my-5" flat outlined>
    <div class="fs-status-header">
      <div class="fs-status-title">{{ equipment.deviceName || equipment.name || '—' }}</div>
      <div class="fs-status-chips">
        <div
          v-for="chip in serviceChips"
          :key="chip.id"
          class="fs-status-chip"
          :class="chip.statusClass"
        >
          <span v-if="chip.serviceLabel" class="fs-status-chip-service">{{ chip.serviceLabel }}</span>
          <span>{{ chip.statusLabel }}</span>
        </div>
      </div>
    </div>

    <div class="fs-status-row mt-3">
      <v-icon size="16" color="#193546">mdi-account-hard-hat-outline</v-icon>
      <span class="fs-status-text">{{ equipment.userDisplay || '—' }}</span>
    </div>

    <div class="fs-status-row">
      <v-icon size="16" color="#193546">mdi-map-marker-outline</v-icon>
      <span class="fs-status-text">{{ equipment.coordinates || '—' }}</span>
    </div>

    <div class="fs-status-row">
      <v-icon size="16" :color="hasChart ? '#0098E1' : '#8FA3AD'">mdi-file-document-outline</v-icon>
      <span class="fs-status-text">{{ chartLabel }}</span>
    </div>
  </v-card>
</template>

<script>
import { resolveSurveyWorkUiStatus } from '@/lib/surveyWorkStatus'
import { assignedServices } from '@/lib/surveyWorkServices'

export default {
  name: 'FieldSurveyStatusCard',
  props: {
    equipment: {
      type: Object,
      required: true
    }
  },
  computed: {
    members () {
      if (Array.isArray(this.equipment.works) && this.equipment.works.length) {
        return this.equipment.works
      }
      return [this.equipment]
    },
    serviceChips () {
      const rank = { fieldSurvey: 0, uniformity: 1 }
      return this.members
        .map((work) => {
          const uiStatus = resolveSurveyWorkUiStatus(work, work.linkedReport)
          const serviceKey = assignedServices(work)[0]
          return {
            id: work.id || serviceKey || uiStatus,
            serviceKey,
            serviceLabel: serviceKey ? this.$t('EquipmentServices.' + serviceKey) : '',
            statusLabel: this.statusLabelFor(uiStatus),
            statusClass: `status-${uiStatus}`
          }
        })
        .sort((a, b) => (rank[a.serviceKey] != null ? rank[a.serviceKey] : 9) - (rank[b.serviceKey] != null ? rank[b.serviceKey] : 9))
    },
    hasChart () {
      if (this.equipment.hasPluviometricChart || (this.equipment.pluviometricChart && String(this.equipment.pluviometricChart).trim())) {
        return true
      }
      return this.members.some((work) => work.hasPluviometricChart || (work.pluviometricChart && String(work.pluviometricChart).trim()))
    },
    chartLabel () {
      return this.hasChart
        ? this.$t('FieldSurveyForm.pluviometricChartYes')
        : this.$t('FieldSurveyForm.pluviometricChartNo')
    }
  },
  methods: {
    statusLabelFor (uiStatus) {
      const key = `Audits.FieldSurveyStatus.${uiStatus}`
      return this.$te(key) ? this.$t(key) : uiStatus
    }
  }
}
</script>

<style scoped lang="stylus">
.fs-status-card
  border-radius 4px !important
  border 1px solid #ebeff2 !important
  background #ffffff !important
  padding 22px 18px 18px

.fs-status-header
  display flex
  align-items center
  justify-content space-between
  gap 16px

.fs-status-title
  min-width 0
  flex 1 1 auto
  color #173142
  font-size 2rem
  font-weight 500
  line-height 1.2
  word-break break-word

.fs-status-chips
  display flex
  flex-wrap wrap
  justify-content flex-end
  gap 8px
  flex 0 1 auto
  max-width 60%

.fs-status-chip
  display inline-flex
  align-items center
  gap 6px
  padding 4px 10px
  border-radius 3px
  font-size 1rem
  line-height 1.1
  color #6b7b84
  background #f0f3f5

.fs-status-chip-service
  font-weight 600

.status-new
  background #efefef
  color #88959c

.status-inProgress
  background #fff2bf
  color #a08000

.status-completed
  background #deffe9
  color #2c8c55

.status-reportPending
  background #e8f3fb
  color #1565a8

.fs-status-row
  display flex
  align-items center
  gap 12px
  margin-top 8px

.fs-status-text
  color #4f5f67
  font-size 1.04rem
  line-height 1.3
  word-break break-word
</style>



// WEBPACK FOOTER //
// FieldSurveyStatusCard.vue?3e318a3a